<div [ngClass]="customClasses" class="quiz-header d-flex justify-content-between align-items-center">
  <!-- Left: Content Projection -->
  <div class="header-content flex-grow-1">
    <ng-content></ng-content>
  </div>

  <!-- Center: Progress Bar (if enabled) -->
  <div *ngIf="progressBar" class="progress-container flex-grow-1 mx-4">
    <div class="progress" style="height: 12px; border-radius: 10px;">
      <div class="progress-bar progress-bar-striped progress-bar-animated" [ngClass]="progressBarClass"
        [style.width.%]="progressValue" role="progressbar" [attr.aria-valuenow]="progressValue" [attr.aria-valuemin]="0"
        [attr.aria-valuemax]="100">
      </div>
    </div>
    <small class="text-muted d-block text-center mt-1 fw-bold">
      {{ progressValue | number:'1.0-0' }}% {{ 'TESTS.COMPLETE' | translate }}
    </small>
  </div>

  <!-- Right: Timers and Actions -->
  <div class="header-actions d-flex align-items-center gap-3">
    <!-- Question Timer (if enabled) -->
    <div *ngIf="showQuestionTimer && questionTimeSeconds >= 0" class="timer-box p-2 px-3 border rounded"
      [class.bg-warning-light]="isQuestionTimerWarning" [class.bg-danger-light]="isQuestionTimerDanger">
      <div class="d-flex align-items-center gap-2">
        <i class="fas fa-stopwatch" [ngClass]="questionTimerClass"></i>
        <div class="d-flex flex-column">
          <small class="text-muted fw-bold" style="font-size: 9px; line-height: 1;">
            {{ 'TESTS.QUESTION_TIME' | translate }}
          </small>
          <span class="fw-bold fs-6" [ngClass]="questionTimerClass">
            {{ questionTimerDisplay }}
          </span>
        </div>
      </div>
    </div>

    <!-- Test Timer -->
    <div *ngIf="showTestTimer && totalSeconds != null" class="timer-box p-2 px-3 border rounded" [class.bg-warning-light]="isTimerWarning"
      [class.bg-danger-light]="isTimerDanger">
      <div class="d-flex align-items-center gap-2">
        <i *ngIf="iconStart" [class]="iconStart" [ngClass]="timerClass"></i>
        <div class="d-flex flex-column">
          <small class="text-muted fw-bold" style="font-size: 9px; line-height: 1;">
            {{ 'TESTS.TOTAL_TIME' | translate }}
          </small>
          <span class="fw-bold fs-5" [ngClass]="timerClass">
            {{ testTimerDisplay }}
          </span>
        </div>
        <i *ngIf="iconEnd" [class]="iconEnd" [ngClass]="timerClass"></i>
      </div>
    </div>

    <!-- Download Button (if enabled) -->
    <app-button *ngIf="quizButton" [type]="'button'" [icon]="'fa fa-download me-1'"
      [label]="'QUIZ.DOWNLOAD' | translate" [customClasses]="'btn-primary d-flex align-items-center gap-2'">
    </app-button>
  </div>
</div>